import { Directive } from '@angular/core';

@Directive({
    selector: '[wlmGridButtonsThirdSlot]',
    standalone: false
})
export class GridButtonsThirdSlotDirective {}
